'use client';

import { useEffect } from 'react';

import { useTranslation } from '@/lib/i18n/i18n.client';
import { Logger } from '@/lib/Logging';

import ErrorPageContent from '@/app/ErrorFile';

const logger = new Logger('GlobalError handler');

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { texts } = useTranslation();

  useEffect(() => {
    logger.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorPageContent message={texts.error_page.something_went_wrong} />
      </body>
    </html>
  );
}
